import { ClubDetailItemFragment } from '@amf/shared/types/graphql';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import Container from '@amf/shared/components/layout/Container';
import { GetServerSideProps } from 'next';
import { sdk } from '@amf/shared/lib/graphQlClient';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Header from '@amf/shared/components/layout/Header';
import ClubList from '@amf/shared/components/club/ClubList';
import ClubItem from '@amf/shared/components/club/ClubItem';
import { useTranslate } from '@tolgee/react';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

interface ClubListPageProps extends NavigationProps {
  clubs: ClubDetailItemFragment[];
}

export default function ClubListPage({ clubs, navigation, partners }: ClubListPageProps) {
  const { t } = useTranslate();
  return (
    <div className='ClubListPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={t('club.list.title')} />
        <Header title={t('club.list.title')} />
        <Container>
          <ClubList>
            {clubs.map(club => (
              <ClubItem key={club.id} club={club} prefix={AppLinks.club} />
            ))}
          </ClubList>
        </Container>
      </Layout>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<ClubListPageProps> = async ({
  locale,
  res,
}) => {
  res.setHeader('Cache-Control', 'max-age=0, s-maxage=3600');
  const { clubs } = await sdk.ClubList({ union: process.env.NEXT_PUBLIC_UNION });
  return {
    props: {
      clubs,
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
  };
};
